<template>
<div>
<proc_wrapper :procs="procs" :modals="modals" > </proc_wrapper>
</div>
</template>




<script>
import axios from 'axios'
import proc_wrapper from './proc_wrapper.vue'
export default {
components:{proc_wrapper},
 data: function(){
  return {
   procs: {
     selected: {},
     items: [],
     toDelete: {},
   },
   modals:{
     creator:false,
     deleter:false,
     params: false,
   },
  }
},
created(){

},
mounted( ){

},
destroyed(){


},

computed:{


},
methods:{

}
}
</script>


<style>

</style>
